import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Constants } from '../../../components/utils/constants';
import { environment } from '../../../../environments/environment';
import { BankProfile } from '../../../components/utils/bank-profile';
import { BankDetailService } from '../../../components/service/bank-detail.service';
import { HttpService } from '../../../components/service/http.service';
import { Router } from '@angular/router';
import { TruckAccountInfo } from '../../../components/utils/truck-account-info';
import { InvoicePayment } from '../../../components/utils/invoice-payment';
import {  DatePipe, formatDate } from '@angular/common';
import { AuthorizationService } from '../../authorization/authorization.service';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { AssetListResponse } from '../../../shared/models/assetListResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PayoffResponseBeanList } from '../../../shared/payoffResponseBeanList';
import { ContractNumberRequest } from '../../../shared/models/contractNumberResponse';
import { AccoutDetailsResponse } from '../../../shared/models/accountDetailsResponse';
import { SelectionModel } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { Banner } from '../../../shared/models/banner';
import { DTFHomepageService } from '../../dtfhomepage/dtfhomepage.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../../utils/sharedTranslateModule';
import { PayComponent } from '../../pay/pay.component';
import { MatIconModule } from '@angular/material/icon';
import {provideNativeDateAdapter} from '@angular/material/core';
import { InvoiceFileData } from '../../../shared/invoiceFileData';
import { InvoiceList } from '../../../shared/invoiceList';
import { InvoiceResponse } from '../../../shared/invoiceResponse';
import { PayCopyComponent } from '../../pay copy/paycopy.component';
import { WindowRef } from '../../../utils/window';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { TranslateService } from '@ngx-translate/core';
import { PayoffDialogComponent } from '../../payoff/payoff.component';
import { AuthorizeDialogComponent } from '../onlinepayment/onlinepayment.component';
import { MatDialog } from '@angular/material/dialog';
import { monthlypaymentRequestlist } from '../../../../../src/app/shared/models/monthlypaymentRequestlist';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SessionTimeoutComponent } from '../../sessionTimeout/sessionTimeout.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

interface Requests {
  value: string;
  viewValue: string;
}

interface Payments {
  value: string;
  viewValue: string;
}

export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-statementpayment',
    templateUrl: './statementpayment.component.html',
    styleUrls: [],
    providers: [provideNativeDateAdapter(),provideNgxMask()],
    imports: [SharedTranslateModule,SessionTimeoutComponent, NgxMaskDirective, NgxMaskPipe,
        MatPaginator, MatSort, MatTableModule, MatInputModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatDatepickerModule, MatSortModule, MatIconModule
    ]
})
export class StatementpaymentComponent implements OnInit {

  bankDetailObj: BankProfile = new BankProfile;
  step1DisplayedColumns = ['invoiceNum', 'invoiceDate', 'invoiceDueDate', 'invoiceAmount']
  step2DisplayedColumns = ['invoiceNumber', 'invoiceAmt', 'statementpaymentDate', 'transacationId', 'status']
  totalPaymentAmout: any=0;
  rowSelected: boolean;
  AuthorizeBoolean: boolean
  Authorize: any;
  modelText: number;
  dtf_Url: any;
  selected: any;
  profiles: any;
  invoicePayment: InvoicePayment[] = [];
  userAccountInfo:any;
  agentView: boolean;
  page: string;
  blocked: boolean;
  ciamId = sessionStorage.getItem('loginID');
  getMultiPayoffRequest: any ={};
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  terminationDate ='';
  brandId: string;
  assetListRes: AssetListResponse[]; 
  DataSource: MatTableDataSource<AssetListResponse>;
  isFrench = false;
  language = '';
  payoffResponseBeanList : PayoffResponseBeanList[];
  displaycontractNumberList ='';
  titleAuthNumberList: ContractNumberRequest[];
  token: string;
  rowCount = 0;
  isdropdown= true;
  showtextbox=false;
  currentCountry: string;
  public alerts: Banner;
  dbData: any;
  langFlag: string;
  countryFlag: string;
  bodyLoaded = false;
  endDate: string;
  startDate: string;
  invoiceList: InvoiceList[];
  invoiceRes: InvoiceResponse[];
  invoiceFileData: InvoiceFileData[];
  statementpaymentstep1 = true;
  statementpaymentstep2 = false;
  statementpaymentstep3 = false;
  contractSelected = false;
  tableLoaded = false;
  accountSelected = false;
  selectedInvoiceResponseList: InvoiceResponse[];
  customerName: string;
  minDate: Date;
  maxDate: Date;
  azURL: string;
  usUrl: string;
  caUrl: string;
  routingNumber: string;
  trans_history = false;
  invalid: boolean=false;
  required = false;
  selectone = false;
  totalAmount: number = 0;
  amount1: number = 0;  // Amount entered by the user
  isAmountEntered: boolean = false;  // Flag to control div visibility
  currentDate: Date;
  amount: boolean=false;
  selectedPayment: string | null = null;
  dropDownList: Array<any>=[];
  loaded: boolean;
  dtpayCustomerId: String = "";
  dtpayPaymentMethodToken: String = '';
  lineitemsList: monthlypaymentRequestlist;
  line_items: monthlypaymentRequestlist[];
  reference: string;
  status: string;
  currentDates: Date;
  billingaddressnumber: string;
  paymentDate: string;
  agentview: string;
  failureError = false;
  baseRedirect = '';
  dtpayMaskedAccountNumber: String = "";
  selectedPayments: Payments[] = [
    {value: 'make payments', viewValue: 'Make a Payment'},
    {value: 'principal payments', viewValue: 'Principal Payment'},
    {value: 'recurring payments', viewValue: 'Recurring Payment'},
    {value: 'statement payments', viewValue: 'Statement Payment'},
    {value: 'payment history', viewValue: 'Payment History'},
    {value: 'manage profile', viewValue: 'Manage Bank Profile'},
    
  ];
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;
  paymentLineItem: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  selection = new SelectionModel<InvoiceResponse>(true, []);
  dataSource: MatTableDataSource<InvoiceResponse>;
  pipe: DatePipe;
  
  
  constructor(private cdr: ChangeDetectorRef, private router: Router, private httpService: HttpService, private bankDetailService: BankDetailService,public auth: AuthorizationService, private dtfhomepageService: DTFHomepageService, private _window: WindowRef, public translate: TranslateService, public dialog: MatDialog) { 

    this.invoiceRes =[];
    this.line_items = [];
    this.currentDates = new Date();
    dataSource: MatTableDataSource<InvoiceResponse>;
    this.endDate = this.formatDate(new Date()); // Get today's date
    this.startDate = this.formatDate(this.subtractMonths(new Date(), 6)); // 3 months ago
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    this.maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+ 60);
    this.currentDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
  }

 

  initStatementColumns: any[] = [
    {
      name: 'select',
      display: '',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'invoiceNumber',
      display: 'Statement Number',
      dispFormat: 'acct'
    }, 
    {
      name: 'invoiceDueAmount',
      display: 'Payable Amount',
      dispFormat: 'invoiceamount'
    },
    {
      name: 'invoiceDueDate',
      display: 'Due Date',
      dispFormat: 'currentduedate'
    }  
  ];
  displayedStatementColumns: any[] = this.initStatementColumns.map(col => col.name);

  initStatementColumnsStep2: any[] = [
    {
      name: 'invoiceNumber',
      display: 'Statement Number',
      dispFormat: 'acct'
    }, 
    {
      name: 'invoiceDueAmount',
      display: 'Payable Amount',
      dispFormat: 'invoiceamount'
    },
    {
      name: 'invoiceDueDate',
      display: 'Payment Date',
      dispFormat: 'currentduedate'
    }  
  ];
  displayedStatementColumnsStep2: any[] = this.initStatementColumnsStep2.map(col => col.name);

  initColumns: any[] = [
    {
      name: 'invoiceNumber',
      display: 'Statement Number',
      dispFormat: 'acct'
    }, 
    {
      name: 'invoiceDueAmount',
      display: 'Payment Amount',
      dispFormat: 'invoiceamount'
    },
    {
      name: 'invoiceDueDate',
      display: 'Payment Date',
      dispFormat: 'currentduedate'
    },
    {
      name: 'transaction',
      display: 'Transaction Id',
      dispFormat: 'transaction'
    },
    {
      name: 'status',
      display: 'Status',
      dispFormat: 'status'
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  ngOnInit(): void {
    this.langInit();
    // this.tableData=ELEMENT_DATA
    this.billingaddressnumber = sessionStorage.getItem('billingNumber');
    this.thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
    this.brandId = sessionStorage.getItem('brandId');
    this.customerName = sessionStorage.getItem('customerName');
    this.paymentLineItem = sessionStorage.getItem('paymentLineItem');
    this.onLoad();
    // if(sessionStorage.getItem('agentView')=="true"){
    //   this.agentView=true
    // }else{
    //  this.agentView=false
    // }
    this.agentview = sessionStorage.getItem('agentview');
    this.page=sessionStorage.getItem('page')
    this.isFrench = ('fr-CA' === this.language) ? true : false; 
      this.token = sessionStorage.getItem('ciamToken');
      const language = (window as any).mbfs.language;
      this.language= language;
      const country = (window as any).mbfs.country;
      this.countryFlag = country;
      this.langFlag = language;
      this.accounts();
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

    // Checks if what language user is to redirect to correct href in link nav
    if (this.language === 'en-CA') {
        this.baseRedirect = this.usUrl + '/ca/en/';
    } else if (this.language === 'fr-CA') {
        this.baseRedirect = this.usUrl + '/ca/fr/';
    } else {
        this.baseRedirect = this.usUrl;
    }
    this.isFrench = ('fr-CA' === this.language) ? true : false; //checks if language is french or english for Canada
  }


  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;  
    if (this.selectedState === 1) {
      this.azURL =  this.usUrl + '/home/principalpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 2) {
      this.azURL =  this.usUrl + '/home/paymenthistory';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 3) {
      this.azURL =  this.usUrl + '/home/statementpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 4) {
      this.azURL =  this.usUrl + '/home/bankprofile';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 6) {
      this.azURL =  this.usUrl + '/home/recurringpayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 7) {
      this.azURL =  this.usUrl + '/home/onlinepayment';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    }
    else if (this.selectedState === 8) {
      this.azURL =  this.usUrl + '/home/help';
      setTimeout(() => {
        this._window.nativeWindow.location.href = this.azURL;
    }, 1000);
    } 
  }

  onLoad(){
    this.dropDownList=[];
    const request = {
      "thirdPartyId" : this.thirdPartyNumber,
       "userId" : this.ciamId
    }
      this.auth.bankProfile(request).subscribe(res => {
       if(res.length==0){     
              sessionStorage.setItem('online-page-navigation', "Online-Payment")
              sessionStorage.setItem('userExist',"true")
              this.router.navigate(['/home/addprofile']);
            }else{
              sessionStorage.setItem('userExist',"false")
              this.profiles=res;
      
            this.profiles.forEach((element: any) => {
              let option=element.bankName+" "+element.maskedAccountNumber.substr(element.maskedAccountNumber.length - 4)
              let obj={selection: option, id:element.id}
              // if(element["saveProfile"]){
                this.dropDownList.push(obj);
              //   }
                this.selected=this.dropDownList[0]["id"];
            })
          
            this.bankDetailObj=this.profiles[0];
            this.bankDetailService.setObject(this.bankDetailObj);
            this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
            this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
            this.dtpayMaskedAccountNumber=this.bankDetailObj.maskedAccountNumber;
            this.loaded=true;
          }
       
      }, error=>{ 
         if(error.status){
           this.loaded=true;
         }
    });
    }
 
    onChange(){
      let index=this.profiles.findIndex((obj:any)=>obj.id===this.selected)
      this.bankDetailObj=this.profiles[index];
      this.bankDetailService.setObject(this.bankDetailObj);
      this.dtpayCustomerId = this.bankDetailObj.dtpay_customer_id;
      this.dtpayPaymentMethodToken = this.bankDetailObj.dtpay_payment_method_token;
  
    }

    getSelectedBankName(): string {
      const selectedBank = this.dropDownList.find(opt => opt.id === this.selected);
      return selectedBank ? selectedBank.selection : '';  // Return the bank name or an empty string if not found
    }



  subtractMonths(date: Date, months: number): Date {
    const newDate = new Date(date);
    newDate.setMonth(newDate.getMonth() - months);
    return newDate;
  }
  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }
  dropdown(){
    this.isdropdown = false;
    this.showtextbox = true;
  }

  applyFilterAcc(input: string) {
    this.dataSource.filterPredicate = (data: InvoiceResponse, f: string) =>
      !f ||
      data.invoiceNumber.toLowerCase().includes(f)
    input = input.trim(); // Remove whitespace
    input = input.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = input;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  dueDateControl = new FormControl('', [
  this.invalidDateValidator
  ]);

  invalidDateValidator(control: FormControl) {
  if (!control.value) return null;

  const value = control.value;

  // If it's a Date object (from datepicker)
  if (value instanceof Date && !isNaN(value.getTime())) {
    return null;
  }

  // If user manually typed string
  if (typeof value === 'string') {
    const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;

    if (!regex.test(value)) {
      return { invalidDate: true };
    }

    const parts = value.split('/');
    const month = +parts[0] - 1;
    const day = +parts[1];
    const year = +parts[2];

    const date = new Date(year, month, day);

    return (
      date.getFullYear() === year &&
      date.getMonth() === month &&
      date.getDate() === day
    )
      ? null
      : { invalidDate: true };
  }

  return { invalidDate: true };
}
 

  applyFilterDate(filterValue: string) {
    this.pipe = new DatePipe('en-US');
    if (filterValue) {
      filterValue = formatDate(new Date(filterValue), 'MM/dd/yyyy', 'en-US');
    }
    const defaultPredicate = this.dataSource.filterPredicate;
    this.dataSource.filterPredicate = (data, filter) => {
      // If no filter is applied, show all rows
      if (!filter) {
        return true;
      }
      const formatted = this.pipe.transform(data.invoiceDueDate, 'MM/dd/yyyy');
    
      return formatted?.indexOf(filter) >= 0 || defaultPredicate(data, filter);
    };
    this.dataSource.filter = filterValue ? filterValue.trim().toLowerCase() : '';
    if (!filterValue) {
      this.dataSource.filter = ''; // Reset filter to show all data
    }
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }

  applyFilterCurrentAmountDue(input1: string) {
    // Check if input1 is empty. If it is, reset the filter and show all rows.
    if (!input1) {
      this.dataSource.filter = ''; // Reset the filter to show all data
      this.rowCount = this.dataSource.filteredData.length;
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
      return; // Return early as we don't need to filter
    }
  
    // Remove commas from the user input for comparison (keeping the backend data unchanged)
    const filterValue = input1.replace(/,/g, '').toLowerCase(); // Remove commas and convert to lowercase
  
    // Update the filterPredicate to match the data with the cleaned input value
    this.dataSource.filterPredicate = (data: InvoiceResponse, f: string) => {
      // Ensure the data is in lowercase for case-insensitive comparison
      const formattedAmount = data.invoiceDueAmount.toString().toLowerCase(); // Convert to string and lower case
      return formattedAmount.includes(f);
    };
  
    // Clean the input: remove leading/trailing whitespace and convert to lowercase
    input1 = input1.trim(); // Remove leading/trailing whitespace
  
    this.dataSource.filter = filterValue; // Apply the cleaned filter value
  
    // If a paginator exists, reset it to the first page
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  
    // Update the row count based on filtered data
    this.rowCount = this.dataSource.filteredData.length;
  }
  

  accounts(){
    this.tableLoaded = false;
    const invoiceRequest = {
      ccanId: this.thirdPartyNumber,
      ciamAZCode: this.token,
      brandId: this.brandId
     
    };
    this.auth.getInvoiceList(invoiceRequest).subscribe(res => {
      this.invoiceList = [];
      this.invoiceRes = [];
      this.invoiceFileData = [];
      this.invoiceRes = res.viewInvoiceDetails;
      this.dataSource = new MatTableDataSource(this.invoiceRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.calculateTotalAmount();
      this.tableLoaded = true;
    });
  }

 
  onSubmit(){
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected < 1 || numSelected > 50) {
      this.contractSelected = false;
      this.invalid = true;
      this.selectone = true;
    }else{
      this.contractSelected = true;
      this.selectone = false;
    }

   if(!this.invalid && this.selected && !this.contractSelected){
    this.statementpaymentstep1 = false;
    this.checkToggleSelectedForAll();
    this.statementpaymentstep2 = true;
   }else if(this.selected && this.contractSelected){
    this.statementpaymentstep1 = false;
    this.checkToggleSelected();
    this.statementpaymentstep2 = true;  
   }

  if(!this.selected){
    this.invalid=true;
    this.required = true;
  }else {
    this.required = false;
  }
  if(this.totalAmount > 2000000){
    this.amount = true;
    this.selectone = false;
    this.invalid=true;
  }
  }

 

  checkToggleSelected(){
    this.selectedInvoiceResponseList = [];
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected < 1) {
      this.auth.SetErrorMessage('Please select at least one account');
    }
    else {
      this.accountSelected = true;
    }
    for (var i = 0; i < this.selection.selected.length; i++) {
     this.selectedInvoiceResponseList = this.selection.selected;
     this.dataSource = new MatTableDataSource(this.selectedInvoiceResponseList);
     this.dataSource.paginator = null;
     this.dataSource.sort = this.sort;
    }
  }

  checkToggleSelectedForAll(){
    this.tableLoaded = false;
    this.accounts();
    this.selectedInvoiceResponseList = [];
    this.selectedInvoiceResponseList = this.invoiceRes;
    this.dataSource = new MatTableDataSource(this.selectedInvoiceResponseList);
    this.dataSource.paginator = null;
    this.dataSource.sort = this.sort;
    this.tableLoaded = true;
  }

  calculateTotalAmount(): void {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if(numSelected < 1){
    this.totalAmount = 0;
   }else {
    this.totalAmount = 0;
    for(var i = 0; i < this.selection.selected.length; i++ ){
    this.totalAmount += this.selection.selected[i].invoiceDueAmount;
    }
    this.totalAmount = parseFloat(this.totalAmount.toFixed(2));
  } 
  }

  back2step1(){
    window.location.reload();
    this.statementpaymentstep1 = true;
    this.statementpaymentstep2 = false;
  }

  StatementPaymentAuthorize(){
   this.opendialog();
  }

  opendialog(){
    const dialogRef = this.dialog.open(AuthorizeDialogComponent, {
      data: { amount1: this.totalAmount, agentView: this.agentView }  
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { 
          this.isAmountEntered = true;
          this.statementpaymentstep1 = false;
          this.statementpaymentstep2 = false;
          this.statementpaymentstep3 = true;
          this.tableLoaded = false;

        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;

        const selectedRows = this.selection.selected;
        
        

         
        this.selection.selected.forEach((row, index) => {
          this.lineitemsList = new monthlypaymentRequestlist();
          this.lineitemsList.position = index + 1;
          this.lineitemsList.dollarAmount = row.invoiceDueAmount;
          this.lineitemsList.invoice_data = {
            billing_address_number: this.billingaddressnumber || '',    
            third_party_number: this.thirdPartyNumber || '',          
            company_number: row.invoiceNumber.slice(0, 3) || '',                  
            company_year: row.invoiceNumber.slice(3, 5) ? parseInt(`20${row.invoiceNumber.slice(3, 5)}`, 10) : 0 || 0,                       
            number: row.invoiceNumber.slice(5) || '',                         
          };

          this.line_items.push(this.lineitemsList);
        });

        const request = {
          paymentLineItem: this.paymentLineItem,
          userId: this.ciamId,
          maskedAccountNumber: this.dtpayMaskedAccountNumber,
          "customer_id": this.dtpayCustomerId,
          "payment_type": "STATEMENT",
          "payment_settings": {
          "payment_method": {
            "token": this.dtpayPaymentMethodToken,
            "type": "FIRST_PAYMENT"   
          }
          },
          "line_items": this.line_items
        }

        console.log("Monthly Payment Request",request);

        this.auth.orders(request).subscribe(res => {
          if (res.statusMessage === "FAILURE") {
            this.failureError = true;
          }
          console.log("Payment Response",res);
          const order = res[0]; // pick first item
          this.reference = order?.reference;
          this.paymentDate = order?.created_at;
          const paymentStatus = order?.payment?.status;
          if (paymentStatus === "COMPLETED") {
            this.status = "COMPLETED";
          } else if (paymentStatus === "FAILED") {
            const failureMessage =
              order?.payment?.transactions?.[0]?.failure_reasons?.[0]?.message;
            const extractedReason = failureMessage
              ?.split("responseMessage:")?.[1]
              ?.trim();
            this.status = extractedReason
              ? `FAILED (${extractedReason})`
              : "FAILED";
          } else {
            this.status = "IN PROCESS";
          }
          
          console.log("Reference ID",this.reference);
          console.log("Status",this.status);
          
          if(res){
            this.tableLoaded = true;
          }
        });
      }
    });
  }

  BacktoDashBoard(){
    this._window.nativeWindow.location.href = '/home/dashboard';
  }

  DownloadPdf() {
    const doc = new jsPDF({ format: 'a4' });
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    var base64Img =
        'data:image/jpeg;base64,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';
      if (base64Img) {
        doc.addImage(base64Img, 'JPEG', pageWidth - 195, 15, 50, 10);
      }
      doc.setFont('Arial', 'bold');
      doc.text('Customer Name:', 15, 45);
      doc.setFont('Arial', 'normal');
      doc.text(this.customerName, 45, 45);

    var Header = [];
     Header = [
      ["Statement Number", "Payment Amount", "Payment Date","Transaction id", "Status"]
    ];
  
   
    var rows = [];
    const head = Header;
    const data = this.selectedInvoiceResponseList;
  
    // Loop through data and prepare rows
    data.forEach(element => {
      
     // Create a Date object from paymentDate (assuming it's in a valid string format)
    const paymentDate = new Date(element.invoiceDueDate);
  
    // Extract month, day, and year
    const month = paymentDate.getMonth() + 1;  // getMonth() returns a zero-based index (0 = January, 11 = December)
    const day = paymentDate.getDate();
    const year = paymentDate.getFullYear();

    // Format the date as MM/dd/yyyy (pad month and day with zero if necessary)
    const formattedDate = `${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}/${year}`;

      var temp = [
        element.invoiceNumber,
        "$" + element.invoiceDueAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        this.paymentDate.split('T')[0],
        this.reference,
        this.status
      ];

      rows.push(temp);
    });
  
    // Table Configuration
    const marginTop = 40; // Top margin where the table starts
    const rowHeight = 10; // Height of each row in the table (adjust as needed)
    const headerHeight = 10; // Height of the header row
  
    // Add the table
    autoTable(doc,{
      head: head,
      body: rows,
      theme: 'grid',
      headStyles: { fillColor: [79, 77, 74] },
      margin: { top: marginTop }, // Start the table below the verbiage
    });
  
    // Calculate the total height of the table based on rows
    const tableHeight = (rows.length * rowHeight) + headerHeight; // Height of all rows plus the header
    const tableBottomY = marginTop + tableHeight;
  
    // Add footer text or additional verbiage below the table
    doc.setFontSize(12);
    
    // Wrap "Thank you for your payment." text
    const thankYouText = this.translate.instant('onlinepayment.auth');
    const maxWidth = 190; // Adjust this based on your document width
    const wrappedThankYouText = doc.splitTextToSize(thankYouText, maxWidth);
  
    // Add wrapped text
    let currentY = tableBottomY + 10; // Starting Y position for wrapped text
    wrappedThankYouText.forEach(line => {
      doc.text(line, 14, currentY);
      currentY += 6; // Adjust the line spacing as needed
    });
  
    // Add new paragraph with bold first word and checkbox
    const nextParagraphY = currentY + 10; // Position for next paragraph
  
    // Bold the first word in the paragraph
    doc.setFont("Arial", "bold");
    doc.text('Notice:', 14, nextParagraphY ); // First word in bold
  
    // Switch to regular font for the rest of the paragraph
    doc.setFont("Arial", "normal");
  
    // Text to wrap
    const paragraphText = 'The entry of a future dated payment transaction shall not be deemed or construed as acceptance by DTFS of a promise to pay in the future, a deferred payment offer or an amendment to the payment due dates in my lease, retail installment contract or promissory note and security agreement.';
    
    // Split the text to fit the width
    const wrappedText = doc.splitTextToSize(paragraphText, maxWidth);
  
    // Add each line of wrapped text to the PDF
    let currentTextY = nextParagraphY + 5; // Starting Y position for the wrapped text
    wrappedText.forEach(line => {
      doc.text(line, 14, currentTextY);
      currentTextY += 6; // Adjust line spacing as needed
    });
  
    const checkboxX = 14;
    const checkboxY = currentTextY + 5;
    const checkboxSize = 5;

    // Draw the checkbox (square)
    doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

    // Draw a tick mark inside the checkbox
    doc.setLineWidth(0.5);
    doc.setDrawColor(0); // black tick
    // Draw the tick manually as two lines
    doc.line(checkboxX + 1, checkboxY + checkboxSize / 2, checkboxX + 2, checkboxY + checkboxSize - 1); // short stroke
    doc.line(checkboxX + 2, checkboxY + checkboxSize - 1, checkboxX + checkboxSize - 1, checkboxY + 1); // long stroke

    // Add label next to the checkbox
    doc.setFont("Arial", "normal");
    doc.text('I have read and accept the terms of the above Authorization Statement.', checkboxX + checkboxSize + 3, checkboxY + checkboxSize - 1);
  

    this.addHeaderFooters(doc)
    // Save the document as a PDF
    doc.save('Receipt.pdf');

  }

  addHeaderFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.width;
    let translate = this.translate;

    doc.setFont('Arial', 'Normal');
    doc.setFontSize(8);


    for (var i = 1; i <= pageCount; i++) {

      //Pagination
      doc.setPage(i);
      doc.text('Page ' + String(i) + ' of ' + String(pageCount),
        pageWidth / 2, 279, {
        align: 'center',
      }
      );

      if (i <= 2 || i == pageCount) {
        // sign  
        doc.text(translate.instant('Payoff.payofffooter_line1'), pageWidth - 72, 270, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line2'), pageWidth - 72, 274, { align: 'left' });
        doc.text(translate.instant('Payoff.payofffooter_line3'), pageWidth - 72, 278, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line4'), pageWidth - 72, 282, { align: 'left', });
        doc.text(translate.instant('Payoff.payofffooter_line5'), pageWidth - 72, 286, { align: 'left' }
        );
      }
    }

  };
  


   
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

}
